import { render, staticRenderFns } from "./SkeletonLoader.vue?vue&type=template&id=6d662690&scoped=true"
var script = {}
import style0 from "./SkeletonLoader.vue?vue&type=style&index=0&id=6d662690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d662690",
  null
  
)

export default component.exports